import { useEffect } from 'react';
import { Header, ContentContainer } from 'prosci-ui';
import { usePageContext } from '@/contexts/page-context';
import { DomainsTab } from '../kaiya-config/domains-tab';

export function KaiyaDomainsPage() {
  const { setShowPageHeader } = usePageContext();

  useEffect(() => {
    setShowPageHeader(false);
    return () => setShowPageHeader(true);
  }, [setShowPageHeader]);

  return (
    <>
      <Header
        title="Domains"
        description="Manage knowledge domains for Kaiya's AI routing and content organization"
      />
      <ContentContainer>
        <DomainsTab />
      </ContentContainer>
    </>
  );
}
